<template>
  <li :class="{ 'active-background': $route.path === item.to }">
    <div class="menu-item item" >
      <component
        :is="componentIs"
        :to="itemTo"
        :href="itemHref"
        exact-active-class="is-active"
      >
        <span v-if="item.label" class="bold default" @click="menuClick">{{ item.label }}</span>
      </component>
      <aside-menu-list
        v-if="hasDropdown"
        :menu="item.menu"
        :isSubmenuList="true"
      />
    </div>
  </li>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AsideMenuItem",
  data() {
    return {
      isDropdownActive: false
    };
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  methods: {
    ...mapActions({
      logout: "logout"
    }),
    menuClick() {
      if (this.item.to == "/login") {
        this.logout();
      }
      this.$emit("menu-click", this.item);

      if (this.hasDropdown) {
        this.isDropdownActive = !this.isDropdownActive;
      }
    }
  },
  computed: {
    componentIs() {
      return this.item.to ? "router-link" : "a";
    },
    hasDropdown() {
      return !!this.item.menu;
    },
    itemTo() {
      return this.item.to ? this.item.to : null;
    },
    itemHref() {
      return this.item.href ? this.item.href : null;
    }
  }
};
</script>
